// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calc-main { 
	width: 374px;
}

.blanco{
	opacity: 0;
}

.calc-main {
	display: block;
    padding: 16px 10px 18px;
    font: bold 15px/28px Arial, Helvetica, sans-serif;
    border-radius: 12px;
    box-shadow: inset 0px -38px 5px rgb(36 36 41 / 26%), inset 0px 6px 4px rgb(255 255 255 / 25%), inset 0px 2px 1px rgb(255 255 255 / 25%), inset 3px 0px 3px rgb(255 255 255 / 25%), inset -4px 0px 4px rgb(0 0 0 / 75%);
    background: #878787;
    background: linear-gradient(to bottom, #a0a1ab 45%,#282828 80%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#141414', endColorstr='#282828',GradientType=0 );
}
.calc-main:after {
	content: "";
	display: block;
	clear: both;
}

.calc-display {
	position: relative;
	height: 60px;
	margin: 0 5px 6px 5px;
	padding: 0 8px;
	border-radius: 5px;
	box-shadow:
		inset 0 30px 1px rgba(255, 255, 255, 0.25),
		inset 0 -1px 2px rgba(255, 255, 255, 0.5),
		inset 0  2px 3px rgba(  0,   0,   0, 0.40);
	font-size: 45px;
	line-height: 61px;
	text-align: right;
	white-space: nowrap;
	color: #333;
	cursor: default;
	text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.01); /* for nicer/smoother rendering */
	background: #edefe0; /* Old browsers */ /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
	background: linear-gradient(to bottom,  #edefe0 45%,#babea2 80%); /* W3C */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#edefe0', endColorstr='#babea2',GradientType=0 ); /* IE6-9 */
}
.calc-rad {
	position: absolute;
	bottom: 2px;
	font-size: 14px;
	line-height: 14px;
	left: 11px;
}
.calc-small .calc-rad {
	display: none;
}
.calc-hold {
	position: absolute;
	right: 5px;
	bottom: 1px;
	font-size: 8px;
	line-height: 13px;
	color: #666;
	height: 12px;
}

.calc-buttons {
	position: absolute;
	top: 2px;
	left: 2px;
	opacity: .35;
	height: 14px;
	width: 14px;
	transition:
		opacity 0.15s ease-in;
}
.calc-buttons:hover {
	opacity: 0.75;
	height: 100%;
	width: 17px;
}
.calc-buttons div {
	position: absolute;
	top: 1px;
	height: 11px;
	width: 11px;
	font-size: 8px;
	text-align: center;
	text-decoration: none;
	line-height: 12px;
	text-indent: 1px;
	color: #333;
	cursor: default;
	border-radius: 50%;
	border: 1px solid #444;
}
.calc-buttons .calc-smaller {
	opacity: 0;
}
.calc-buttons .calc-ln {
	font-size: 17px;
	line-height: 2px;
	overflow: hidden;
	opacity: 0;
}
.calc-buttons:hover div {
	transition:
		opacity 0.15s ease-in,
		top 0.25s ease-out;
}

.calc-buttons:hover .calc-smaller {
	top: 15px;
	opacity: 0.75;
}
.calc-buttons:hover .calc-ln {
	top: 29px;
	opacity: 0.75;
}
.calc-buttons .calc-info:hover, .calc-buttons .calc-smaller:hover, .calc-buttons .calc-ln:hover {
	opacity: 1;
}

/* -------- key board -------- */

.calc-left, .calc-right {
	position: relative;
	float: left;
	width: 100%;
	background: #90c2d3;
	border-bottom: 2px solid #eaeaea;
}

.calc-small .calc-left {
	display: none;
}
.calc-f17 {
	font-size: 17px;
}
.calc-f18 {
	font-size: 18px;
}
.calc-f19 {
	font-size: 19px;
}
.calc-f21 {
	font-size: 21px;
}
.calc-main textarea {
	position: absolute;
	width: 1px;
	height: 1px;
	left: 4px;
	top: 4px;
	border: 0;
	background-color: transparent;
}

/* -------- key board keys -------- */

.calc-left > div, .calc-right > div {
	margin: 3px 2px;
	position: relative;
	width: 40px;
	height: 24px;
	background-color: #4c5356;
	border: 1px solid black;
	box-shadow: 0 1px rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	overflow: hidden;
	float: left;
	cursor: default;
}
.calc-left > div > div, .calc-right > div > div {
	position: absolute;
	top: 0px;
	right: 0px;
	height: 28px;
	left: 0px;
	width: 100%;
	border: 1px solid #000;
	border-radius: 6px;
	color: #eee;
	text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.5);
	text-align: center;
	background: #656e72;
	
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border-bottom-left-radius: 26px 6px;
	border-bottom-right-radius: 26px 6px;
	box-shadow:
		inset 0 -15px 1px rgba(  0,   0,   0, 0.25),
		inset 0   1px 1px rgba(255, 255, 255, 0.4),
		inset 0   6px 6px rgba(255, 255, 255, 0.25);
	border: none;
}
.calc-left > div > div:hover, .calc-right > div > div:hover {
	text-shadow:
		0px  0px  8px  rgb(255, 230, 186),
		0px  0px 22px  rgb(255, 255, 255),
		0px -1px  0px rgba(  0,   0,   0, 0.5);
}
.calc-right .calc-eq {
	height: 28px;
	position: absolute;
	bottom: 0;
	right: 5px;
	background-color: #EA6811;
}

.calc-radxy sup {
	padding-bottom: 4px;
	display: block;
	position: absolute;
	left: 14px;
	top: 6px;
}
.calc-radxy em {
	font-weight: normal;
	font-size: 16px;
	padding-right: 2px;
}
.calc-right .calc-zero {
	width: 40px;
}
.calc-right .calc-zero div {
	text-align: left;
}
.calc-right .calc-zero span {
	padding-left: 22px;
}
.calc-blank {
	border-color: transparent;
	background: none;
	background-image: none;
	box-shadow: none;
	clear: right;
}
.calc-right .calc-brown > div {
	background-color: #635045;
}
.calc-right .calc-brown {
	background-color: #4b3c34;
}

.calc-right .calc-black > div {
	background-color: #000;
	box-shadow:
		inset 0 -13px 1px rgba(50,   50,  50, 0.5),
		inset 0   1px 1px rgba(255, 255, 255, 0.25),
		inset 0   8px 6px rgba(255, 255, 255, 0.2);
}
.calc-right .calc-black {
	background-color: #181818;
}
.calc-right .calc-orange > div {
	background-color: #FF7113;
	box-shadow:
		inset 0 -13px 1px rgba(148,  77,  18, 0.20),
		inset 0  7px  6px rgba(255, 255, 255, 0.3),
		inset 0  6px  6px rgba(255, 255, 255, 0.1);
}
.calc-left > div:active, .calc-right > div:active,
.calc-left .calc-press, .calc-right .calc-press {
	box-shadow:
		inset 0 -9px 6px rgba(255, 255, 255, 0.35),
			  0  1px     rgba(255, 255, 255, 0.15);
}
.calc-left > div:active > div, .calc-right > div:active > div,
.calc-left .calc-press > div, .calc-right .calc-press > div {
	background: none;
	box-shadow:
		inset 0 1px 1px rgba(255, 255, 255, 0.3);
}
.calc-left .calc-active, .calc-right .calc-active {
	box-shadow:
		 1px  1px     rgb(220, 220, 240),
		-1px -1px     rgb(220, 220, 240),
		 1px -1px     rgb(220, 220, 240),
		-1px  1px     rgb(220, 220, 240),
		 2px  2px 2px rgb(220, 220, 240),
		-2px -2px 2px rgb(220, 220, 240),
		 2px -2px 2px rgb(220, 220, 240),
		-2px  2px 2px rgb(220, 220, 240);
	border-color: #333;
}
.calc-left .calc-second {
	background-color: #222;
}
.calc-left .calc-second div {
	text-shadow: 0 1px 0 rgba(0, 0, 0, 0.7);
	color: #EA6811;
}
sup, sub {
	font-size: 10px;
	line-height: 0;
	padding-left: 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/calculadora/calculadora.component.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;IACX,uBAAuB;IACvB,iDAAiD;IACjD,mBAAmB;IACnB,sNAAsN;IACtN,mBAAmB;IAMnB,+DAA+D;IAC/D,mHAAmH;AACvH;AACA;CACC,WAAW;CACX,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,qBAAqB;CACrB,cAAc;CACd,kBAAkB;CAClB;;;4CAG2C;CAC3C,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;CACnB,WAAW;CACX,eAAe;CACf,yCAAyC,EAAE,iCAAiC;CAC5E,mBAAmB,EAAE,iBAAiB,EAC4B,WAAW,EACkC,oBAAoB,EAC/D,yBAAyB,EAC9B,iBAAiB,EAChB,UAAU;CAC1E,gEAAgE,EAAE,QAAQ;CAC1E,mHAAmH,EAAE,UAAU;AAChI;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,cAAc;CACd,iBAAiB;CACjB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,WAAW;CACX;uBACsB;AACvB;AACA;CACC,aAAa;CACb,YAAY;CACZ,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,UAAU;AACX;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;AACX;AACA;CACC;;oBAEmB;AACpB;;AAEA;CACC,SAAS;CACT,aAAa;AACd;AACA;CACC,SAAS;CACT,aAAa;AACd;AACA;CACC,UAAU;AACX;;AAEA,gCAAgC;;AAEhC;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,gCAAgC;AACjC;;AAEA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,SAAS;CACT,QAAQ;CACR,SAAS;CACT,6BAA6B;AAC9B;;AAEA,qCAAqC;;AAErC;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,uBAAuB;CACvB,0CAA0C;CAC1C,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,YAAY;CACZ,SAAS;CACT,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,wCAAwC;CACxC,kBAAkB;CAClB,mBAAmB;;CAEnB,2BAA2B;CAC3B,4BAA4B;CAC5B,mCAAmC;CACnC,oCAAoC;CACpC;;;6CAG4C;CAC5C,YAAY;AACb;AACA;CACC;;;wCAGuC;AACxC;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;AACA;CACC,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB;;;4CAG2C;AAC5C;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB;;;4CAG2C;AAC5C;AACA;;CAEC;;yCAEwC;AACzC;AACA;;CAEC,gBAAgB;CAChB;0CACyC;AAC1C;AACA;CACC;;;;;;;;kCAQiC;CACjC,kBAAkB;AACnB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,uCAAuC;CACvC,cAAc;AACf;AACA;CACC,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB","sourcesContent":[".calc-main { \r\n\twidth: 374px;\r\n}\r\n\r\n.blanco{\r\n\topacity: 0;\r\n}\r\n\r\n.calc-main {\r\n\tdisplay: block;\r\n    padding: 16px 10px 18px;\r\n    font: bold 15px/28px Arial, Helvetica, sans-serif;\r\n    border-radius: 12px;\r\n    box-shadow: inset 0px -38px 5px rgb(36 36 41 / 26%), inset 0px 6px 4px rgb(255 255 255 / 25%), inset 0px 2px 1px rgb(255 255 255 / 25%), inset 3px 0px 3px rgb(255 255 255 / 25%), inset -4px 0px 4px rgb(0 0 0 / 75%);\r\n    background: #878787;\r\n    background: -moz-linear-gradient(top, #a0a1ab 45%, #282828 80%);\r\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(45%,#b4b7bf), color-stop(80%,#b3b5c2));\r\n    background: -webkit-linear-gradient(top, #a0a1ab 45%,#282828 80%);\r\n    background: -o-linear-gradient(top, #a0a1ab 45%,#282828 80%);\r\n    background: -ms-linear-gradient(top, #a0a1ab 45%,#282828 80%);\r\n    background: linear-gradient(to bottom, #a0a1ab 45%,#282828 80%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#141414', endColorstr='#282828',GradientType=0 );\r\n}\r\n.calc-main:after {\r\n\tcontent: \"\";\r\n\tdisplay: block;\r\n\tclear: both;\r\n}\r\n\r\n.calc-display {\r\n\tposition: relative;\r\n\theight: 60px;\r\n\tmargin: 0 5px 6px 5px;\r\n\tpadding: 0 8px;\r\n\tborder-radius: 5px;\r\n\tbox-shadow:\r\n\t\tinset 0 30px 1px rgba(255, 255, 255, 0.25),\r\n\t\tinset 0 -1px 2px rgba(255, 255, 255, 0.5),\r\n\t\tinset 0  2px 3px rgba(  0,   0,   0, 0.40);\r\n\tfont-size: 45px;\r\n\tline-height: 61px;\r\n\ttext-align: right;\r\n\twhite-space: nowrap;\r\n\tcolor: #333;\r\n\tcursor: default;\r\n\ttext-shadow: 0 -1px 0 rgba(0, 0, 0, 0.01); /* for nicer/smoother rendering */\r\n\tbackground: #edefe0; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #edefe0 45%, #babea2 80%); /* FF3.6+ */\r\n\tbackground: -webkit-gradient(linear, left top, left bottom, color-stop(45%,#edefe0), color-stop(80%,#babea2)); /* Chrome,Safari4+ */\r\n\tbackground: -webkit-linear-gradient(top,  #edefe0 45%,#babea2 80%); /* Chrome10+,Safari5.1+ */\r\n\tbackground: -o-linear-gradient(top,  #edefe0 45%,#babea2 80%); /* Opera 11.10+ */\r\n\tbackground: -ms-linear-gradient(top,  #edefe0 45%,#babea2 80%); /* IE10+ */\r\n\tbackground: linear-gradient(to bottom,  #edefe0 45%,#babea2 80%); /* W3C */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#edefe0', endColorstr='#babea2',GradientType=0 ); /* IE6-9 */\r\n}\r\n.calc-rad {\r\n\tposition: absolute;\r\n\tbottom: 2px;\r\n\tfont-size: 14px;\r\n\tline-height: 14px;\r\n\tleft: 11px;\r\n}\r\n.calc-small .calc-rad {\r\n\tdisplay: none;\r\n}\r\n.calc-hold {\r\n\tposition: absolute;\r\n\tright: 5px;\r\n\tbottom: 1px;\r\n\tfont-size: 8px;\r\n\tline-height: 13px;\r\n\tcolor: #666;\r\n\theight: 12px;\r\n}\r\n\r\n.calc-buttons {\r\n\tposition: absolute;\r\n\ttop: 2px;\r\n\tleft: 2px;\r\n\topacity: .35;\r\n\theight: 14px;\r\n\twidth: 14px;\r\n\ttransition:\r\n\t\topacity 0.15s ease-in;\r\n}\r\n.calc-buttons:hover {\r\n\topacity: 0.75;\r\n\theight: 100%;\r\n\twidth: 17px;\r\n}\r\n.calc-buttons div {\r\n\tposition: absolute;\r\n\ttop: 1px;\r\n\theight: 11px;\r\n\twidth: 11px;\r\n\tfont-size: 8px;\r\n\ttext-align: center;\r\n\ttext-decoration: none;\r\n\tline-height: 12px;\r\n\ttext-indent: 1px;\r\n\tcolor: #333;\r\n\tcursor: default;\r\n\tborder-radius: 50%;\r\n\tborder: 1px solid #444;\r\n}\r\n.calc-buttons .calc-smaller {\r\n\topacity: 0;\r\n}\r\n.calc-buttons .calc-ln {\r\n\tfont-size: 17px;\r\n\tline-height: 2px;\r\n\toverflow: hidden;\r\n\topacity: 0;\r\n}\r\n.calc-buttons:hover div {\r\n\ttransition:\r\n\t\topacity 0.15s ease-in,\r\n\t\ttop 0.25s ease-out;\r\n}\r\n\r\n.calc-buttons:hover .calc-smaller {\r\n\ttop: 15px;\r\n\topacity: 0.75;\r\n}\r\n.calc-buttons:hover .calc-ln {\r\n\ttop: 29px;\r\n\topacity: 0.75;\r\n}\r\n.calc-buttons .calc-info:hover, .calc-buttons .calc-smaller:hover, .calc-buttons .calc-ln:hover {\r\n\topacity: 1;\r\n}\r\n\r\n/* -------- key board -------- */\r\n\r\n.calc-left, .calc-right {\r\n\tposition: relative;\r\n\tfloat: left;\r\n\twidth: 100%;\r\n\tbackground: #90c2d3;\r\n\tborder-bottom: 2px solid #eaeaea;\r\n}\r\n\r\n.calc-small .calc-left {\r\n\tdisplay: none;\r\n}\r\n.calc-f17 {\r\n\tfont-size: 17px;\r\n}\r\n.calc-f18 {\r\n\tfont-size: 18px;\r\n}\r\n.calc-f19 {\r\n\tfont-size: 19px;\r\n}\r\n.calc-f21 {\r\n\tfont-size: 21px;\r\n}\r\n.calc-main textarea {\r\n\tposition: absolute;\r\n\twidth: 1px;\r\n\theight: 1px;\r\n\tleft: 4px;\r\n\ttop: 4px;\r\n\tborder: 0;\r\n\tbackground-color: transparent;\r\n}\r\n\r\n/* -------- key board keys -------- */\r\n\r\n.calc-left > div, .calc-right > div {\r\n\tmargin: 3px 2px;\r\n\tposition: relative;\r\n\twidth: 40px;\r\n\theight: 24px;\r\n\tbackground-color: #4c5356;\r\n\tborder: 1px solid black;\r\n\tbox-shadow: 0 1px rgba(255, 255, 255, 0.1);\r\n\tborder-radius: 6px;\r\n\toverflow: hidden;\r\n\tfloat: left;\r\n\tcursor: default;\r\n}\r\n.calc-left > div > div, .calc-right > div > div {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\tright: 0px;\r\n\theight: 28px;\r\n\tleft: 0px;\r\n\twidth: 100%;\r\n\tborder: 1px solid #000;\r\n\tborder-radius: 6px;\r\n\tcolor: #eee;\r\n\ttext-shadow: 0 -1px 0 rgba(0, 0, 0, 0.5);\r\n\ttext-align: center;\r\n\tbackground: #656e72;\r\n\t\r\n\tborder-top-left-radius: 6px;\r\n\tborder-top-right-radius: 6px;\r\n\tborder-bottom-left-radius: 26px 6px;\r\n\tborder-bottom-right-radius: 26px 6px;\r\n\tbox-shadow:\r\n\t\tinset 0 -15px 1px rgba(  0,   0,   0, 0.25),\r\n\t\tinset 0   1px 1px rgba(255, 255, 255, 0.4),\r\n\t\tinset 0   6px 6px rgba(255, 255, 255, 0.25);\r\n\tborder: none;\r\n}\r\n.calc-left > div > div:hover, .calc-right > div > div:hover {\r\n\ttext-shadow:\r\n\t\t0px  0px  8px  rgb(255, 230, 186),\r\n\t\t0px  0px 22px  rgb(255, 255, 255),\r\n\t\t0px -1px  0px rgba(  0,   0,   0, 0.5);\r\n}\r\n.calc-right .calc-eq {\r\n\theight: 28px;\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\tright: 5px;\r\n\tbackground-color: #EA6811;\r\n}\r\n\r\n.calc-radxy sup {\r\n\tpadding-bottom: 4px;\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tleft: 14px;\r\n\ttop: 6px;\r\n}\r\n.calc-radxy em {\r\n\tfont-weight: normal;\r\n\tfont-size: 16px;\r\n\tpadding-right: 2px;\r\n}\r\n.calc-right .calc-zero {\r\n\twidth: 40px;\r\n}\r\n.calc-right .calc-zero div {\r\n\ttext-align: left;\r\n}\r\n.calc-right .calc-zero span {\r\n\tpadding-left: 22px;\r\n}\r\n.calc-blank {\r\n\tborder-color: transparent;\r\n\tbackground: none;\r\n\tbackground-image: none;\r\n\tbox-shadow: none;\r\n\tclear: right;\r\n}\r\n.calc-right .calc-brown > div {\r\n\tbackground-color: #635045;\r\n}\r\n.calc-right .calc-brown {\r\n\tbackground-color: #4b3c34;\r\n}\r\n\r\n.calc-right .calc-black > div {\r\n\tbackground-color: #000;\r\n\tbox-shadow:\r\n\t\tinset 0 -13px 1px rgba(50,   50,  50, 0.5),\r\n\t\tinset 0   1px 1px rgba(255, 255, 255, 0.25),\r\n\t\tinset 0   8px 6px rgba(255, 255, 255, 0.2);\r\n}\r\n.calc-right .calc-black {\r\n\tbackground-color: #181818;\r\n}\r\n.calc-right .calc-orange > div {\r\n\tbackground-color: #FF7113;\r\n\tbox-shadow:\r\n\t\tinset 0 -13px 1px rgba(148,  77,  18, 0.20),\r\n\t\tinset 0  7px  6px rgba(255, 255, 255, 0.3),\r\n\t\tinset 0  6px  6px rgba(255, 255, 255, 0.1);\r\n}\r\n.calc-left > div:active, .calc-right > div:active,\r\n.calc-left .calc-press, .calc-right .calc-press {\r\n\tbox-shadow:\r\n\t\tinset 0 -9px 6px rgba(255, 255, 255, 0.35),\r\n\t\t\t  0  1px     rgba(255, 255, 255, 0.15);\r\n}\r\n.calc-left > div:active > div, .calc-right > div:active > div,\r\n.calc-left .calc-press > div, .calc-right .calc-press > div {\r\n\tbackground: none;\r\n\tbox-shadow:\r\n\t\tinset 0 1px 1px rgba(255, 255, 255, 0.3);\r\n}\r\n.calc-left .calc-active, .calc-right .calc-active {\r\n\tbox-shadow:\r\n\t\t 1px  1px     rgb(220, 220, 240),\r\n\t\t-1px -1px     rgb(220, 220, 240),\r\n\t\t 1px -1px     rgb(220, 220, 240),\r\n\t\t-1px  1px     rgb(220, 220, 240),\r\n\t\t 2px  2px 2px rgb(220, 220, 240),\r\n\t\t-2px -2px 2px rgb(220, 220, 240),\r\n\t\t 2px -2px 2px rgb(220, 220, 240),\r\n\t\t-2px  2px 2px rgb(220, 220, 240);\r\n\tborder-color: #333;\r\n}\r\n.calc-left .calc-second {\r\n\tbackground-color: #222;\r\n}\r\n.calc-left .calc-second div {\r\n\ttext-shadow: 0 1px 0 rgba(0, 0, 0, 0.7);\r\n\tcolor: #EA6811;\r\n}\r\nsup, sub {\r\n\tfont-size: 10px;\r\n\tline-height: 0;\r\n\tpadding-left: 1px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
